import { useEffect, useState } from 'react';
import { api } from '../services/api';

type PanelProduct = {
  id: string;
  code: string;
  barcode: string | null;
  name: string;
  price: number;
  availableQuantity: number;
  active: boolean;
  imageUrl: string | null;
  synchronizedAt: string | null;
};

function formatCurrency(value: number): string {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export default function ProductPanel() {
  const [products, setProducts] = useState<PanelProduct[]>([]);
  const [filter, setFilter] = useState('');
  const [editingId, setEditingId] = useState<string | null>(null);
  const [urlInput, setUrlInput] = useState('');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    api.getPanelProducts().then(setProducts).catch(() => {});
  }, []);

  const filtered = products.filter(p =>
    !filter || p.name.toLowerCase().includes(filter.toLowerCase()) || p.code.includes(filter) || (p.barcode && p.barcode.includes(filter))
  );

  async function handleSave(id: string) {
    setSaving(true);
    try {
      await api.updateProductPhoto(id, urlInput || null);
      setProducts(prev => prev.map(p => p.id === id ? { ...p, imageUrl: urlInput || null } : p));
      setEditingId(null);
      setUrlInput('');
      setMessage('Foto atualizada com sucesso');
    } catch (e: any) {
      setMessage(e.message || 'Erro ao salvar');
    }
    setSaving(false);
  }

  function startEdit(product: PanelProduct) {
    setEditingId(product.id);
    setUrlInput(product.imageUrl || '');
    setMessage('');
  }

  return (
    <section className="panel-table-wrap">
      <div className="panel-table-head">
        <h2>Produtos ({products.length})</h2>
        <input
          type="text"
          placeholder="Buscar por nome, codigo ou barras..."
          value={filter}
          onChange={e => setFilter(e.target.value)}
          style={{
            padding: '8px 12px', borderRadius: 6, border: '1px solid #ccc',
            fontSize: 14, width: 300,
          }}
        />
      </div>

      {message && (
        <div style={{ padding: '8px 16px', background: message.includes('sucesso') ? '#d4edda' : '#f8d7da', borderRadius: 6, marginBottom: 12 }}>
          {message}
        </div>
      )}

      <div className="panel-table-wrap" style={{ maxHeight: 'calc(100vh - 280px)', overflow: 'auto' }}>
        <table className="panel-table">
          <thead>
            <tr>
              <th>Codigo</th>
              <th>Nome</th>
              <th>Preco</th>
              <th>Estoque</th>
              <th>Foto</th>
              <th>Acao</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(p => (
              <tr key={p.id}>
                <td>{p.code}</td>
                <td>{p.name}</td>
                <td>{formatCurrency(p.price)}</td>
                <td>{p.availableQuantity}</td>
                <td>
                  {p.imageUrl ? (
                    <img src={p.imageUrl} alt="" style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 4 }} />
                  ) : (
                    <span style={{ color: '#999' }}>Sem foto</span>
                  )}
                </td>
                <td>
                  {editingId === p.id ? (
                    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                      <input
                        type="text"
                        value={urlInput}
                        onChange={e => setUrlInput(e.target.value)}
                        placeholder="Colar URL da foto..."
                        style={{
                          padding: '4px 8px', borderRadius: 4, border: '1px solid #ccc',
                          fontSize: 13, width: 220,
                        }}
                      />
                      <button
                        onClick={() => handleSave(p.id)}
                        disabled={saving}
                        style={{
                          padding: '4px 12px', borderRadius: 4, border: 'none',
                          background: '#1557D6', color: '#fff', cursor: 'pointer',
                        }}
                      >
                        {saving ? 'Salvando...' : 'Salvar'}
                      </button>
                      <button
                        onClick={() => { setEditingId(null); setUrlInput(''); }}
                        style={{
                          padding: '4px 8px', borderRadius: 4, border: '1px solid #ccc',
                          background: '#fff', cursor: 'pointer',
                        }}
                      >
                        Cancelar
                      </button>
                    </div>
                  ) : (
                    <button
                      onClick={() => startEdit(p)}
                      style={{
                        padding: '4px 12px', borderRadius: 4, border: '1px solid #1557D6',
                        background: '#fff', color: '#1557D6', cursor: 'pointer',
                      }}
                    >
                      Adicionar foto
                    </button>
                  )}
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={6} style={{ textAlign: 'center', color: '#999', padding: 32 }}>Nenhum produto encontrado</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
